/**
 * Created by anatoly on 18.10.2024
 */

const DangerWarningAnimation = cc.Scale9Sprite.extend({
    ctor: function (type, component) {
        this._super(bundles.danger_component.frames.warning);

        this.type = type;

        this.setOpacity(0);

        this.onResize();

        component.on("onNoMuchTime", this.startWarningAnimation.bind(this));
        component.on("onStop", this.stopAnimation.bind(this));
    },

    onResize: function () {
        const bgRect = cleverapps.resolution.getBgRect();
        this.setContentSize(this.width, bgRect.height);

        const styles = cleverapps.styles.DangerWarningAnimation;

        const x = styles[this.type].x;
        const y = styles.y;

        if (this.type === DangerWarningAnimation.TYPES.RIGHT) {
            this.setScaleX(-1);
        }

        this.setAlignment(x, y, { box: cleverapps.resolution.getBgRect() });
    },

    startWarningAnimation: function () {
        this.runAction(new cc.RepeatForever(
            new cc.Sequence(
                new cc.FadeIn(0.8),
                new cc.FadeOut(0.8)
            )
        ));

        this.runAction(new cc.RepeatForever(
            new cc.Sequence(
                new cc.CallFunc(function () {
                    this.sound = cleverapps.effects.fire("danger.tricky.siren");
                }),
                new cc.DelayTime(1.6)
            )
        ));
    },

    stopAnimation: function () {
        this.stopAllActions();
        this.runAction(new cc.FadeOut(0.4));

        cleverapps.audio.stopSound(this.sound);
    }
});

DangerWarningAnimation.TYPES = {
    RIGHT: "right",
    LEFT: "left"
};

cleverapps.styles.DangerWarningAnimation = {
    y: { align: "center" },

    left: {
        x: { align: "left" }
    },

    right: {
        x: { align: "right" }
    }
};